import { SensorSelectionContext } from 'context';
import { SensorSelectionActions } from 'context/sensor-selection-context/action-types';
import {
  loadSensorSelection,
  LoadSensorOptions,
} from 'context/sensor-selection-context/init';
import { useContext, useEffect } from 'react';

type UseLoadSensorSelectionOptions = LoadSensorOptions;

const useLoadSensorSelection = (
  options: UseLoadSensorSelectionOptions = {
    loadCamera: true,
    loadMicrophone: true,
  },
) => {
  const { updateSensorSelection } = useContext(SensorSelectionContext);
  const { loadCamera = true, loadMicrophone = true } = options;

  // Make sure sensor selection is loaded
  useEffect(() => {
    const initializeSensors = async () => {
      const selection = await loadSensorSelection({
        loadCamera,
        loadMicrophone,
      });
      updateSensorSelection({
        type: SensorSelectionActions.SENSOR_SELECTION_LOADED,
        data: selection,
      });
    };
    initializeSensors();
  }, [loadCamera, loadMicrophone]);
};

export { useLoadSensorSelection };
